import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const theme = {
  primary: '#00bfc5',
  secondary: '#206ee1',
}

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: theme,
    },
  },
});
